import { PdfContentClient, PageContent as PdfPageContent, ParagraphContent, PdfImageInfo, Pdfinfo } from "../Generated/ParticaAPI";
import { PageContent, PageContentItem, PageBox, LoadPageContent } from "../Models/Components.model";

export interface IPdfContentService {
	getPageContent(issueId: number, page: number, load: LoadPageContent): Promise<PageContent>;
	getPageContentInception(issueId: number, page: number, load: LoadPageContent): Promise<PageContent>;
	getPageInfo(issueId: number): Promise<Pdfinfo>;
}

export class PdfContentService implements IPdfContentService {
	private svc: PdfContentClient = new PdfContentClient();
	// Get pages content to overlay on to image of page.
	// converts pdf coords to image coords.


	public async getPageContentInception(issueId: number, page: number, load: LoadPageContent): Promise<PageContent> {
		const pagecontent: PdfPageContent = await this.svc.getPageContentInception(issueId, page);
		return this.convertContent(pagecontent, load);
	}

	public async getPageInfo(issueId: number): Promise<Pdfinfo> {
		const pagecontent: Pdfinfo = await this.svc.getPdfInfo(issueId);
		return pagecontent;
	}

	public async getPageContent(issueId: number, page: number, load: LoadPageContent): Promise<PageContent> {
		const pagecontent: PdfPageContent = await this.svc.getPageContentHtml(issueId, page);
		return this.convertContent(pagecontent, load);
	}

	private convertContent(pagecontent: PdfPageContent, load: LoadPageContent) {
		const output = new PageContent();
		output.height = pagecontent.height as number;
		output.width = pagecontent.width as number;
		let count: number = 0;

		if (load === LoadPageContent.Text || load === LoadPageContent.All) {
			for (const para of pagecontent.paras as ParagraphContent[]) {
				const pdfPara = this.convertPara(para);
				pdfPara.id = count++;
				pdfPara.box.y = output.height - pdfPara.box.y - pdfPara.box.height; // adjust y coords for pdf-><img>
				output.items.push(pdfPara);
			}
		}
		if (load === LoadPageContent.Images || load === LoadPageContent.All) {
			for (const image of pagecontent.images as PdfImageInfo[]) {
				const pdfImage = this.convertImage(image);
				pdfImage.id = count++;
				pdfImage.box.y = output.height - pdfImage.box.y - pdfImage.box.height; // adjust y coords for pdf-><img>
				output.items.push(pdfImage);
			}
		}
		output.items = output.sorteditems();
		return output;

	}

	// convert paragraph to PageContent
	private convertPara(para: ParagraphContent): PageContentItem {
		const output = new PageContentItem();
		output.box = new PageBox(para.box);
		output.class += "text";
		output.content = para.text as string;
		output.contentstyled = para.html as string;
		output.id = para.id as number;
		output.type = "text";
		return output;
	}
	// convert image to PageContent
	private convertImage(image: PdfImageInfo): PageContentItem {
		const output = new PageContentItem();
		output.box = new PageBox(image.box);
		output.class += "image";
		output.content = image.imageUrl as string;
		output.id = output.box.x * output.box.y;
		output.type = "image";
		return output;
	}


}
